import React from "react";
import "./About2.css";
const About2 = () => {
  return (
    <div className="about2div">
      <div className="imagedivvv">
        <img src="/images/aboutimage.jpg" alt="About Section" />
      </div>
      <div className="textdivvv">
        <h4>
          DAGA GROUP is running by Mr. Rajkumar Daga and Mr. Ashok Daga . We
          started operations in 1973, when our first firm was registered by name
          'Anupam Steel Centre'. We are distributors for JSW Steel Ltd & Rathi
          Group and channel partner of SBF Ispat Pvt Ltd. We deal in all items
          of iron and steel such as: TMT BARS, ANGLES, CHANNELS, BEAMS, MS
          PLATES, HR & CR PLATES , GC SHEET, GISHEET , CHEQUERED PLATE and
          STAINLESS STEEL WIRE RODS. We have our stockyard in Palwal, from where
          we are able to service many locations. Our expertise is in providing
          solutions for any construction related steel demand. We can cater all
          over the country.
        </h4>
      </div>
    </div>
  );
};

export default About2;
